import { render, staticRenderFns } from "./moduleCreateEdit.vue?vue&type=template&id=373c643b&scoped=true&"
import script from "./moduleCreateEdit.vue?vue&type=script&lang=js&"
export * from "./moduleCreateEdit.vue?vue&type=script&lang=js&"
import style0 from "./moduleCreateEdit.vue?vue&type=style&index=0&id=373c643b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373c643b",
  null
  
)

export default component.exports